<div class="acts">
  <app-container>
    <app-bread-crumbs></app-bread-crumbs>

    <h4 class="acts-title">{{ page?.translation?.data?.searchTitle }}</h4>
    <div class="acts-search">
      <app-search-input
        [placeholder]="page?.translation?.data.searchPlaceholder"
        [variant]="'second'"
        (onSearch)="onSearch($event)"
      ></app-search-input>

      <app-filters
        [title]="page?.translation?.data?.filterButtonTitle"
        [filterOptions]="filterOptions"
        [appliedFilters]="appliedFilters"
        (filtersChanged)="onFiltersChanged($event)"
      ></app-filters>
    </div>
  </app-container>

  @if (pra() && pra().length) {
    <div class="acts-wrapper">
      <app-regulatory-acts-list [praList]="pra()"></app-regulatory-acts-list>
      <app-paginator
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [itemsPerPage]="itemsPerPage"
        (pageChange)="onPageChange($event)"
      >
      </app-paginator>
    </div>
  } @else {
    <app-container> <h6 class="h6 empty">Не знайдено</h6></app-container>
  }
</div>
